<template>
  <b-row>
    <b-col cols="12">
      <table-notification />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import TableNotification from '@/views/admin/notification-center/TableNotification.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    TableNotification,
  },

  data() {
    return {
      //
    }
  },

  mounted() {
    //
  },

  methods: {
    //
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
.select2-container b[role='presentation'] {
  display: none !important;
}
</style>

